import React, { useRef } from 'react'
import { Card, Form, Button, Container } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { db } from '../firebase';
import styled from 'styled-components';
import firebase from 'firebase';
import { useAuth } from '../context/AuthContext';

export const NavLogo = styled(Link)`
 color: #fff;
 display:flex;
 justify-self:flex-start;
 align-items:center;
 margin-left:24px;
 font-weight:bold;
 text-decoration:none;
 cursor: pointer;
 &:hover{
     text-decoration:none;
     color:#fff;
 }
`
export default function UploadBlog() {
    const titleRef = useRef();
    const bodyRef = useRef();
    const authorRef = useRef();
    const { currentUser } = useAuth();
    const history = useHistory();
    async function handleSubmit(e) {
        e.preventDefault();
        db.collection('blogs').add({
            title: titleRef.current.value,
            body: bodyRef.current.value,
            author: authorRef.current.value,
            email: currentUser.email,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
        history.push('/');
    }
    return (
        <Container style={{ minHeight: "100vh", minWidth: "100vw", backgroundColor: '#01bf71', overflowY: 'hidden' }}>
            <NavLogo to="/" style={{ position: "absolute", marginTop: '20px' }}> MindSpace</NavLogo>
            <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "90vh", minWidth: "90vw", backgroundColor: '#01bf71' }}>
                <div className="w-100" style={{ maxWidth: "400px", paddingTop: "30px" }}>
                    <Card>
                        <Card.Body>
                            <h2 className="text-center mb-4">Upload Blog</h2>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group id="title">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control type="input" ref={titleRef} required />
                                </Form.Group>
                                <Form.Group id="body">
                                    <Form.Label>Content</Form.Label>
                                    <Form.Control type="input" ref={bodyRef} required />
                                </Form.Group>
                                <Form.Group id="author">
                                    <Form.Label>Author Name</Form.Label>
                                    <Form.Control type="input" ref={authorRef} required />
                                </Form.Group>
                                <Button className="w-100" type="submit">
                                    Upload
                        </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </Container>
        </Container>
    )
}
